import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {
    GetDocumentRestriction,
    GetDocumentRestrictionsingle,
    UpdateDocumentRestriction
} from "../../../../reduxToolkit/restrictions/RestrictionApi";
import {useLocation, useNavigate} from "react-router-dom";
import routes from "../../../../Routes/routes";
const DocumentRestrictionApp = () =>{
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const [emptyFields, setEmptyFields] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const { getDocumentRestriction, updateDocumentRestriction, getDocumentRestrictionsingle } = useSelector(
        (state) => state.RestrictionSlice,
    );

    const handleUpdateDoc = () => {
        if(!value) {
            setEmptyFields(true);
            return;
        }

        setEmptyFields(false);
        const data = {
            id: getDocumentRestrictionsingle?.mediaOptionId,
            mediaOptionId: value,
        };
        dispatch(UpdateDocumentRestriction(data)).then(() =>{
            if(location.pathname?.includes(routes.vehicleDocument.restriction)) navigate(routes.vehicleDocument.list);
            else navigate(routes.document.list);
        });
    };

    useEffect(() => {
        dispatch(GetDocumentRestriction());
    }, []);

    useEffect(() => {
        dispatch(GetDocumentRestrictionsingle());
    }, [updateDocumentRestriction]);

    useEffect(() => {
        setValue(getDocumentRestrictionsingle?.mediaOptionId);
    }, [getDocumentRestrictionsingle?.id]);

    return {
        t,
        value,
        setValue,
        emptyFields,
        navigate,
        handleUpdateDoc,
        getDocumentRestriction
    }
}

export default DocumentRestrictionApp;
